import { render, staticRenderFns } from "./verticalColumnar.vue?vue&type=template&id=54cb3a12&scoped=true"
import script from "./verticalColumnar.vue?vue&type=script&lang=js"
export * from "./verticalColumnar.vue?vue&type=script&lang=js"
import style0 from "./verticalColumnar.vue?vue&type=style&index=0&id=54cb3a12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb3a12",
  null
  
)

export default component.exports